import { createFileRoute } from "@tanstack/react-router";

const ProjectReportRoute = (): null => null;

export const Route = createFileRoute("/_app/settings/projects/$id/report/")({
	component: ProjectReportRoute,
});
